import React, { useState, useEffect } from "react";
import { Docs } from "../Types/SearchResult.interface";
import '../Styles/bookCard.css';
import { GetBookCover } from "../Services/Books.service";

interface BookCardProps {
    book: Docs;
}

const BookCard: React.FC<BookCardProps> = ({ book }) => {
    const [coverLink, setCoverLink] = useState<string>("");

    useEffect(() => {
        const fetchCoverLink = async () => {
            try {
                const link = await GetBookCover('M',book.cover_i);
                setCoverLink(link);
            } catch (error) {
                console.error("Error fetching book cover:", error);
            }
        };

        fetchCoverLink();
    }, [book.cover_i]);

    return (
            <div className="box">
                <div className="box-top">
                    <img
                        src={coverLink}
                        alt={book.title}
                        className="box-image"
                    />
                    <div className="title-flex">
                        <h3 className="box-title">{book.title}</h3>
                        <p className="author-info"> {book.author_name ? book.author_name.join(", ") : "Non spécifié"}</p>
                        <p className="author-info">{book.publish_year ? book.publish_year.toString().slice(0, 4) : "Date inconnue"}</p>
                    </div>
                    <p className="description">{book.subject ? book.subject.slice(0, 1) + ' ...' : "Genre inconnu"}</p>
                </div>
                    <a href="#" className="button">Consulter</a>
            </div>
    );
};

export default BookCard;
